import { formatRouteForAAB } from "./format-route-for-aab.js";
import { wildcardUrlMatcher } from "./wildcard-url-matcher.js";
const applyBloomreachAppointmentUrlsConfiguration = ({
  pathname,
  appointmentRoute,
  appointmentMenuItems,
  content
}) => {
  if (!content || !content.length) {
    return appointmentMenuItems;
  }
  const typeId = content.find((item) => wildcardUrlMatcher(item.url, pathname))?.typeId ?? "";
  if (!typeId) {
    return appointmentMenuItems;
  }
  return formatRouteForAAB({
    appointmentMenuItems,
    appointmentRoute,
    searchParams: new URLSearchParams({ typeId }).toString()
  });
};
export {
  applyBloomreachAppointmentUrlsConfiguration
};
//# sourceMappingURL=apply-bloomreach-appointment-urls-configuration.js.map
